import * as types from './mutation-types';

export default {
  [types.SET_THEME](state, theme) {
    state.currentTheme = theme;
  },
};
